import { useEffect, useState } from "react";
import { useGetVenueByIdMutation } from "../agenda-creation/features/api/getUsers";

interface Props {
  ids: any;
}
export function UtilityVenue(props: Props) {
  const [venueApiid] = useGetVenueByIdMutation();
  const [title, setTitle] = useState<any>("");
  useEffect(() => {
    const tempobj = {
      ids: [props.ids]
    };
    if (props?.ids?.length > 0)
      venueApiid(tempobj)
        .unwrap()
        .then((res) => {
          setTitle(res.data[0].title);
        })
        .catch((err) => {
          console.log("err", err);
        });
  }, [props.ids]);
  return <div className="isolate flex -space-x-1 ">{title}</div>;
}
